<template>
	<div
		class="c-base-placeholder"
		:class="!isMounted && 'c-base-placeholder--is-loading'"
	>
		<Component
			:is="component"
			:id="`c-base-placeholder-${indexInTracker}`"
			:key="indexInTracker"
			class="o-svg-themify"
		/>
	</div>
</template>

<script>
import Vue from 'vue';

const componentTracker = Vue.observable(new Set());
const svgCount = 6;

export default {
	name: 'BasePlaceholder',

	props: {
		index: {
			type: [Number, String],
			default: -1,
		},
	},

	data() {
		return {
			isMounted: false,
			computedIndex: 0,
		};
	},

	computed: {
		indexInTracker() {
			return [...componentTracker].indexOf(this) || 0;
		},

		componentTracker() {
			return componentTracker;
		},

		component() {
			return require(`~/assets/svgs/placeholders/placeholder-${this.computedIndex}.svg?inline`);
		},
	},

	created() {
		componentTracker.add(this);
		this.$watch(
			() => componentTracker,
			() => {
				this.computedIndex = (() => {
					if (this.index >= 0) {
						return this.index % svgCount;
					}
					if (this.indexInTracker > 0) {
						const prevThis = [...componentTracker][
							this.indexInTracker - 1
						];
						if (prevThis === this || !prevThis) {
							return this.index % svgCount;
						}

						const prevIndex = prevThis?.computedIndex || 0;
						return (prevIndex + 1) % svgCount;
					}
					return 0;
				})();
			},
			{ immediate: true }
		);
	},
	beforeMount() {
		this.isMounted = true;
	},
	destroyed() {
		componentTracker.delete(this);
	},
};
</script>

<style lang="postcss">
.c-base-placeholder {
	@apply bg-theme-pattern block w-full;
	aspect-ratio: 413 / 197;

	& > * {
		@apply w-full h-full opacity-0;
	}
}
.c-base-placeholder:not(.c-base-placeholder--is-loading) {
	& > * {
		animation: c-base-placeholder 200ms 1 ease-in forwards;
	}
}

@keyframes c-base-placeholder {
	100% {
		@apply opacity-100;
	}
}
</style>
